import React from "react";
import { Heading1 } from "../../../../components/Headings/Headings";
import { EnvelopeIcon } from "@heroicons/react/24/outline";

const LegalAndContactScreen = () => {
  return (
    <div className="flex flex-col w-full">
      <Heading1 headingText={"Legal & Contact"} />

      <div
        className={
          "flex flex-col md:flex-row items-center justify-between mt-5 mb-10 rounded-lg bg-blue-50 "
        }
      >
        <div className="flex flex-[1] items-center justify-center w-full pt-16 p-10 md:hidden">
          <div className="h-44 w-44 Xmd:h-24 Xmd:w-24 text-neutral-900">
            <EnvelopeIcon />
          </div>
        </div>
        <div className="flex flex-[9] flex-col leading-loose justify-center items-start p-10  text-neutral-800">
          <p className="font-medium text-lg">Dear User,</p>

          <div className="py-2" />
          <p>
            Thank you for taking a moment to familiarize yourself with our key
            policies. Understanding these will ensure a smooth and transparent
            experience on our platform:
          </p>
          <div className="py-2" />
          <p>
            Our{" "}
            <a
              className="text-blue-700 cursor-pointer"
              href="https://dermi.ai/terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>{" "}
            outline the conditions under which you're using our services. It's a
            comprehensive guide to your rights, responsibilities, and the rules
            you agree to follow.
          </p>
          <div className="py-2" />
          <p>
            Your privacy is paramount to us. Our{" "}
            <a
              className="text-blue-700 cursor-pointer"
              href="https://dermi.ai/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>{" "}
            sheds light on how we collect, use, and safeguard your personal
            information.
          </p>
          <div className="py-2" />
          <p>
            For specific details and clarifications about the Clinical Dashboard
            platform, the{" "}
            <a
              className="text-blue-700 cursor-pointer"
              href="https://dermi.ai/clinical-dashboard-disclaimer"
              target="_blank"
              rel="noopener noreferrer"
            >
              Clinical Dashboard Disclaimer
            </a>{" "}
            is here to provide insights.
          </p>
          <div className="py-2" />
          <p>
            We're committed to transparency and trust. If you ever have
            questions about these documents, they're always accessible from this
            section.
          </p>
          <div className="py-2" />
          <p>
            If you have questions about our services, or are curious about our
            research, we're here to help. Please use the contact form at{" "}
            <a
              className="text-blue-700 cursor-pointer"
              href="https://dermi.ai/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              dermi.ai/contact
            </a>{" "}
            or email us directly at{" "}
            <a
              className="text-blue-700 cursor-pointer"
              href="mailto:contact@dermi.ai"
            >
              contact@dermi.ai
            </a>
            . When you submit through our contact form, you'll receive a
            confirmation email with a copy of your message. We'll be in touch
            shortly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LegalAndContactScreen;
